/**
 * MSAL (Microsoft Authentication Library) configuration for Entra ID browser SSO.
 *
 * Uses sessionStorage — not localStorage — to limit blast radius if the page is
 * compromised. The load-bearing XSS controls are the CSP (§11.7), short token
 * lifetime, PKCE, and no implicit grant; sessionStorage here is defence-in-depth.
 */

import type { Configuration } from '@azure/msal-browser'

/**
 * MSAL PublicClientApplication configuration.
 * clientId / authority / redirectUri are resolved from Vite env vars at build time.
 * cacheLocation is 'sessionStorage' — never localStorage.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_SPA_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID as string}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage' as const,
  },
}

/**
 * API scopes requested when acquiring access tokens for the CC API.
 * Consumed by acquireTokenSilent, acquireTokenRedirect, loginRedirect,
 * and the Socket.IO auth callback.
 */
export const apiScopes: string[] = [import.meta.env.VITE_ENTRA_API_SCOPE as string]
